import {AxoisRequestManager} from "../managers/RequestManager";
import {CategorizationApprovalStats} from "../../services/classes/AiClasses";
import {from} from "rxjs";
import {PipeManager} from "../managers/PipeManager";
import {StorePartFeedbackManySerializer, StorePartFeedbackSerializer} from "../../services/classes/MatReviewClasses";
import {ReviewChoice} from "../../services/classes/MaterializedClasses";
import {makeAutoObservable} from "mobx";
import MithraMaterializedApi from "../../services/MithraMaterializedApi";

type StorePartFeedbackPipe = { data: StorePartFeedbackSerializer, partId: number };

export class CategorizationReviewFeedbackDelegate {
    readonly stats = new AxoisRequestManager<number, CategorizationApprovalStats>(
        approvalId => from(this.matApi.getCategorizationApprovalStatsRequest(approvalId))
    )
    readonly accRejPipe = new PipeManager<StorePartFeedbackPipe>(
        ({data, partId}) => from(this.matApi.storePartFeedback(partId, data))
    )
    readonly accRejMultiPipe = new PipeManager<StorePartFeedbackManySerializer>(
        data => from(this.matApi.storePartFeedbackMany(data))
    )
    readonly accRejAllPipe = new PipeManager<{ c: ReviewChoice, approvalId: number }>(
        ({c, approvalId}) => from(this.matApi.storePartFeedbackAll(approvalId, c))
    )

    constructor(
        private matApi: MithraMaterializedApi,
    ) {
        makeAutoObservable(this);
    }

    get numberOfBusyRequests(): number {
        return this.accRejPipe.nInPipe
            + this.accRejMultiPipe.nInPipe
            + this.accRejAllPipe.nInPipe
    }
}
